<template>
  <div>
    <q-item v-if="items[0] === '_OLG_'" tag="label" :dense="dense">
      <q-item-section>
        <q-item-label>{{ label }}</q-item-label>
        <q-item-label caption
          >Please login or register for an account.</q-item-label
        >
      </q-item-section>
      <q-item-section side>
        <q-icon name="lock"></q-icon>
      </q-item-section>
    </q-item>
    <q-field borderless :label="label" stack-label v-else>
      <template v-slot:control>
        <div class="self-center full-width no-outline q-pt-xl">
          <q-range
            :value="filterInput"
            @change="handleFilterInputChange"
            :min="minValue"
            :max="maxValue"
            :step="1"
            label-always
          />
        </div>
      </template>
    </q-field>
  </div>
</template>
<script>
export default {
  name: "Range",
  props: {
    id: {
      required: true,
      type: String,
      default: "",
    },
    label: {
      required: true,
      type: String,
      default: "",
    },
    items: {
      required: true,
      type: Array,
      default() {
        return [];
      },
    },
    dense: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Object,
    },
  },
  data() {
    return {
      filterInput: {
        min: 0,
        max: 0,
      },
    };
  },
  mounted() {
    if (!this.filter) {
      this.filterInput.min = this.minValue;
      this.filterInput.max = this.maxValue;
    }

    this.$root.$on("reset-filter-input", () => {
      console.debug("reset-filter-input in range");

      this.reset();
    });
  },
  beforeDestroy() {
    this.$root.$off("reset-filter-input");
  },
  computed: {
    minValue() {
      const min = Math.min(...this.items);
      const val = Number.isFinite(min) ? min : 0;

      return val;
    },
    maxValue() {
      const max = Math.max(...this.items);
      const val = Number.isFinite(max) ? max : 0;

      return val;
    },
  },
  watch: {
    filterInput(newVal, oldVal) {
      if (newVal && oldVal) {
        if (newVal.min === oldVal.min && newVal.max === oldVal.max) {
          return;
        }
      }

      this.$emit("update", this.id, newVal);
    },
    minValue(newVal) {
      this.filterInput.min = newVal;
    },
    maxValue(newVal) {
      this.filterInput.max = newVal;
    },
    filter: {
      handler: function(newVal) {
        if (newVal) {
          const { min, max } = newVal;

          this.handleFilterInputChange({
            min,
            max,
          });
        }
      },
      immediate: true,
    },
  },
  methods: {
    reset() {
      const min = this.minValue;
      const max = this.maxValue;
      const filterInput = this.filterInput;

      if (filterInput.min === min && filterInput.max === max) {
        return;
      }

      this.handleFilterInputChange({
        min,
        max,
      });
    },
    handleFilterInputChange(e) {
      this.filterInput = e;
    },
  },
};
</script>
<style lang="scss" scoped></style>
